import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";
import { useMemo } from "react";
import { TimelineClassKey } from '@material-ui/lab/Timeline';
import { TimelineContentClassKey } from '@material-ui/lab/TimelineContent';

import Home from "./Home";
import Nav from './Components/NavPenisPenis';
import Page from './Pages/Page';
import TimApple from './Pages/TimApple';

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { createTheme, ThemeProvider } from "@material-ui/core";

declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey {
    MuiTimeline: TimelineClassKey;
    MuiTimelineContent: TimelineContentClassKey;
  }
}

const candyMachineId = new anchor.web3.PublicKey(
  process.env.REACT_APP_CANDY_MACHINE_ID!
);

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

export const themeColors = {
  backgroundColors: {
    darkMint: '#61e1e1',
    darkMintDarkened: '#48C8C8',
    lightMint: '#ddffff',
    light: '#fffcfa',
  },
  colors: {
    dark: '#4a4a4a',
    light: '#fffcfa'
  }
}

const darkFontColor = themeColors.colors.dark;

const theme = createTheme({
  typography: {
    fontSize: 20,
    fontFamily: [
      'DM Mono',
      'monospace',
    ].join(','),
    h1: {
      fontFamily: 'Bitter',
      fontSize: '6rem',
      color: darkFontColor,
    },
    h2: {
      fontFamily: 'Bitter',
      fontSize: '3.75rem',
      color: darkFontColor,
    },
    h3: {
      fontFamily: 'Bitter',
      fontSize: '3rem',
      color: darkFontColor,
    },
    h4: {
      fontFamily: 'Bitter',
      fontSize: '2.125rem',
      color: darkFontColor,
    },
    h5: {
      fontFamily: 'Bitter',
      fontSize: '1.25rem',
      color: darkFontColor,
    },
    h6: {
      fontFamily: 'Bitter',
      fontSize: '3.75rem',
      color: darkFontColor,
    },
    body1: {
      color: darkFontColor,
    }
  },
  palette: {
    background: {
      default: themeColors.backgroundColors.light,
    },
    text: {
      primary: themeColors.colors.dark,
    }, 
    primary: {
      contrastText: themeColors.colors.light,
      main: '#61e1e1', // darker mint green
      // updates Connect Wallet button background for some reason
      // main: '#e19e61'
      // main: '#f44336',
    },
    secondary: {
      main: '#f44336',
    },
  },
    overrides: {
      MuiTimelineContent: {
        root: {
          paddingTop: '0px',
          marginTop: '-4px',
        }
      },
        MuiButtonBase: {
            root: {
                justifyContent: 'flex-start',
            },
        },
        MuiListItem: {
          root: {
            "&:hover": {
              backgroundColor: themeColors.colors.dark,
            },
          }
        },
        MuiIconButton: {
          root: {
            color: themeColors.colors.light,
          },
        },
        MuiButton: {
            root: {
                color: themeColors.colors.light,
                textTransform: undefined,
                padding: '12px 16px',
            },
            startIcon: {
                marginRight: 8,
            },
            endIcon: {
                marginLeft: 8,
            },
        },
    },
});

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
        getPhantomWallet(),
        getSlopeWallet(),
        getSolflareWallet(),
        getSolletWallet({ network }),
        getSolletExtensionWallet({ network })
    ],
    []
  );

  return (
      <ThemeProvider theme={theme}>
        <ConnectionProvider endpoint={endpoint}>
          <WalletProvider wallets={wallets} autoConnect={true}>
            <WalletDialogProvider>
              <Router>
                <Nav />
                <Routes>
                  <Route path="/adopt" element={
                    <Page>
                      <Home
                        candyMachineId={candyMachineId}
                        connection={connection}
                        txTimeout={txTimeout}
                        rpcHost={rpcHost}
                      />
                    </Page>
                  }>
                  </Route>
                  <Route path="/tim-apple" element={
                    <Page>
                      <TimApple />
                    </Page>
                  }>
                  </Route>
                </Routes>
              </Router>
            </WalletDialogProvider>
          </WalletProvider>
        </ConnectionProvider>
      </ThemeProvider>
  );
};

export default App;
